import { keepPreviousData, useQuery } from '@tanstack/react-query';
import DataApiClient from 'src/utils/DataApiClient';
import { QueryDisabledError } from 'src/utils/error/QueryDisabledError';
import { createQueryKey } from 'src/utils/query/createQueryKey';
import {
	AccountTradingMetrics,
	AccountTradingSnapshot,
} from 'src/hooks/query/snapshots/account/types';
import { SNAPSHOTS_QUERY_STALE_TIME } from 'src/hooks/query/snapshots/consts';

function accountTradingSnapshotsQueryKey(userAccount?: string, days?: number) {
	return createQueryKey('accountTradingSnapshots', userAccount, days);
}

interface Params {
	userAccount: string | undefined;
	days: number;
}

interface ResponseData {
	snapshots: AccountTradingSnapshot[];
	metrics: AccountTradingMetrics;
}

export default function useAccountTradingSnapshots({
	userAccount,
	days,
}: Params) {
	const disabled = !userAccount || days <= 0;

	return useQuery({
		queryKey: accountTradingSnapshotsQueryKey(userAccount, days),
		queryFn: () => {
			if (disabled) {
				throw new QueryDisabledError();
			}

			return DataApiClient.fetchSnapshotData<ResponseData>({
				level: 'user',
				resource: 'trading',
				params: {
					userAccount,
					days,
				},
			});
		},
		enabled: !disabled,
		placeholderData: disabled ? undefined : keepPreviousData,
		staleTime: SNAPSHOTS_QUERY_STALE_TIME,
	});
}
